import { render, staticRenderFns } from "./ArticlesParProduit.vue?vue&type=template&id=77c768ce&"
import script from "./ArticlesParProduit.vue?vue&type=script&lang=js&"
export * from "./ArticlesParProduit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c768ce')) {
      api.createRecord('77c768ce', component.options)
    } else {
      api.reload('77c768ce', component.options)
    }
    module.hot.accept("./ArticlesParProduit.vue?vue&type=template&id=77c768ce&", function () {
      api.rerender('77c768ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stock/ArticlesParProduit.vue"
export default component.exports